export default "__VITE_ASSET__DnDtjhw9__"